import { render, staticRenderFns } from "./AppThankYouModal.vue?vue&type=template&id=a5965440&scoped=true"
import script from "./AppThankYouModal.vue?vue&type=script&lang=ts"
export * from "./AppThankYouModal.vue?vue&type=script&lang=ts"
import style0 from "./AppThankYouModal.vue?vue&type=style&index=0&id=a5965440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5965440",
  null
  
)

export default component.exports